import { apiFetch } from '../client';

/**
 * ABM "Etapas de importación" (server: /api/importacion-etapas-plantilla): la
 * plantilla que se copia a cada importación nueva. AR.
 */
export type EtapaPlantilla = {
  /** String para CrudTable. */
  id: string;
  orden: number;
  nombre: string;
  dias: number;
  avisarDiasAntes: number;
  /** A lo sumo una activa; define la fecha probable de llegada. */
  esArribo: boolean;
  status: 'Activo' | 'Inactivo';
};

/** Query key compartida: ABM y alta de importación. */
export const ETAPAS_PLANTILLA_QUERY_KEY = ['configuracion', 'etapas-importacion'] as const;

type Row = Omit<EtapaPlantilla, 'id'> & { id: number };
const aItem = (r: Row): EtapaPlantilla => ({ ...r, id: String(r.id) });

export async function listEtapasPlantilla(): Promise<EtapaPlantilla[]> {
  const res = await apiFetch<{ items: Row[] }>('/api/importacion-etapas-plantilla');
  return res.items.map(aItem);
}

export type EtapaPlantillaPayload = Omit<EtapaPlantilla, 'id'>;

export async function createEtapaPlantilla(p: EtapaPlantillaPayload): Promise<EtapaPlantilla> {
  const res = await apiFetch<{ item: Row }>('/api/importacion-etapas-plantilla', { method: 'POST', body: p });
  return aItem(res.item);
}

export async function updateEtapaPlantilla(id: string, p: EtapaPlantillaPayload): Promise<EtapaPlantilla> {
  const res = await apiFetch<{ item: Row }>(`/api/importacion-etapas-plantilla/${id}`, { method: 'PATCH', body: p });
  return aItem(res.item);
}

export async function softDeleteEtapaPlantilla(id: string): Promise<EtapaPlantilla> {
  const res = await apiFetch<{ item: Row }>(`/api/importacion-etapas-plantilla/${id}`, { method: 'DELETE' });
  return aItem(res.item);
}
